import React, { Component, PropTypes } from 'react';
import { Icon, Badge, Menu, Dropdown, BackTop, message, Spin } from 'antd'
import avatar from "../../../assets/common/img/avatar.png"
import logout from '../../../action/login/logout';
import { connect } from 'react-redux';
// import SSpin from '../../common/SSpin'

const breadcrumbMap = {
  'workflow': [
    // {url: '/dashboard/index.html', name: '功能入口'},
    {url: '/workflow/start.html', name: '工作流程'}
  ]
}

class BreadcrumbBar extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { userMenus } = this.props.user;
    const breadcrumbMap = {
      'workflow': [
        { url: '/dashboard/index.html', name: '功能入口' }
      ]
    }
    if (this.props.links) {
      breadcrumbMap.workflow.push(...this.props.links);
    }
    else {
      //默认
      breadcrumbMap.workflow.push({ url: '/workflow/start.html', name: '工作流程' });
    }
    return (
      <div className="breadcrumb-w">
        {
          breadcrumbMap['workflow'].map((item, index, arr) => {
            if (index !== arr.length - 1) {
              return <span key={index}><a className="link" href={item.url}>{item.name}</a> <Icon type="right" /></span>
            } else {
              return <a key={index} className="current-link" href={item.url}>{item.name}</a>
            }
          })
        }
      </div>
    );
  }
}


function mapStateToProps({ page, user }) {
  return {
    user
  }
}

export default connect(mapStateToProps)(BreadcrumbBar);





// WEBPACK FOOTER //
// ./src/components/layout/breadcrumb/index.js